import { ref } from 'vue'

const stored = typeof window !== 'undefined' ? window.localStorage.getItem('lang') : null
const initial = stored || 'zh'

export const currentLanguage = ref(initial)

export function setLanguage(lang) {
  currentLanguage.value = lang
  try {
    window.localStorage.setItem('lang', lang)
  } catch (e) {
    // ignore
  }
}

export function getLanguage() {
  return currentLanguage.value
}